import { useState } from "react"
import { AiOutlineLoading } from "react-icons/ai"
import Lottie from 'lottie-react';
import { useEffect, useRef } from 'react';
import cogsLoading from "../../assets/lottie/cog_loading.json";

import type { CodeRunStatusKey } from "./types";
import { motion } from "framer-motion";

type CodeRunStatusType = {
    currentStatus: CodeRunStatusKey,
}

const codeRunningStates: Record<CodeRunStatusKey, { fullMessage: string; animation: any }> = {
    "QUEUED": { fullMessage: "Your code is in line. Starting soon.", animation: cogsLoading },
    "EXECUTING": { fullMessage: "Your code's running. Gears are turning.", animation: cogsLoading },
    "EXECUTED": { fullMessage: "Execution complete. That was smooth.", animation: cogsLoading },
    "QUEUED_FOR_EVALUATION": { fullMessage: "Results queued for scoring. Judges getting ready.", animation: cogsLoading },
    "EVALUATING": { fullMessage: "Scoring in progress.", animation: cogsLoading },
    "DONE": { fullMessage: "All set. That's a wrap!", animation: cogsLoading },
    "ERROR_NO_SERVERS_ONLINE": { fullMessage: "Seems like all our servers are busy, please wait a while and try again. Sorry for the inconvience!", animation: cogsLoading },
    "ERROR_UNKNOWN": { fullMessage: "Unknown Error, Please report this by clicking on the report button.", animation: cogsLoading },
}

export default function CodeRunStatus(props: CodeRunStatusType) {

    const containerRef = useRef<HTMLDivElement | null>(null);
    const animationInstance = useRef<any>(null);

    // useEffect(() => {
    //     if (!props.currentStatus || !codeRunningStates[props.currentStatus].fullMessage  ) return;

    //     if (animationInstance.current) {
    //         animationInstance.current.destroy();
    //     }

    //     if (containerRef.current) {
    //         animationInstance.current = lottie.loadAnimation({
    //             container: containerRef.current,
    //             renderer: 'svg',
    //             loop: true,
    //             autoplay: true,
    //             animationData: codeRunningStates[props.currentStatus].animation,
    //         });
    //     }

    //     return () => {
    //     if (animationInstance.current) {
    //         animationInstance.current.destroy();
    //         animationInstance.current = null;
    //     }
    //     };
    // }, [props.currentStatus]);

    return (
        <motion.div 
            className="codeRunStatus_visual"
            initial={{ opacity: 0, scale: .96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: .25,
                ease: "easeInOut"
            }}
        >

            <div className="visual">
                <AiOutlineLoading className="runLoader" size="50px" />
            </div>

            <div className="progress">
                Step { Object.keys(codeRunningStates).indexOf(props.currentStatus) } / {Object.keys(codeRunningStates).length}.
            </div>

            <div className="text">
                {codeRunningStates[props.currentStatus].fullMessage}
            </div>

            <div ref={containerRef}>

                <Lottie
                    animationData={cogsLoading}
                />

            </div>

        </motion.div>
    )
}